import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const updateAppConfModalSelector = createSelector(modalsSelector, (modals) => modals.updateAppConf);

export default updateAppConfModalSelector;
